import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../../../hooks';
import { GanttMode, PlanView, useProductionPlanQueryParams } from '../hooks';
import { toggleBrigadeDrawer } from './BrigadeDrawer';
import { toggleProductionPlanTasksDrawer } from './TasksDrawer';
import { useGraphneTodoList } from '../../../../queryHooks/productionPlanHooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSidebar } from '@fortawesome/pro-light-svg-icons';

export const TasksOrBrigadeButton = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');
  const { queryParams } = useProductionPlanQueryParams();
  const isBrigadeButton = queryParams.view === PlanView.GANTT && queryParams.mode === GanttMode.WORKER;
  const { data } = useGraphneTodoList(!isBrigadeButton);

  const totalTaskCount = data?.total || 0;

  if (isBrigadeButton) {
    return (
      <Button
        StartIcon={<FontAwesomeIcon className="h-5 min-w-5" icon={faSidebar} />}
        variant="outlined"
        onClick={toggleBrigadeDrawer}
      >
        {tWrapper('brigade')}
      </Button>
    );
  }

  return (
    <Button
      withIndicator
      count={totalTaskCount}
      StartIcon={<FontAwesomeIcon className="h-5 min-w-5" icon={faSidebar} />}
      variant="outlined"
      onClick={toggleProductionPlanTasksDrawer}
    >
      {tWrapper('tasks')}
    </Button>
  );
};
